var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_815_113530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4852 20.4861C22.4485 18.523 23.6703 15.9399 23.9425 13.1768C24.2147 10.4138 23.5204 7.64195 21.9779 5.33345C20.4355 3.02496 18.1403 1.32271 15.4835 0.516757C12.8267 -0.289199 9.9726 -0.148996 7.40756 0.913478C4.84252 1.97595 2.72524 3.89496 1.41648 6.34351C0.107723 8.79207 -0.311534 11.6187 0.230145 14.3417C0.771825 17.0647 2.24093 19.5157 4.38713 21.2769C6.53333 23.0382 9.22384 24.0008 12.0002 24.0008C15.1827 24.0007 18.2348 22.7364 20.4852 20.4861Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12.666L10.0002 15.3327L16.6668 8.66602",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_113530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.890932f72046edeb71eecda55d729640.svg";
export { ForwardRef as ReactComponent };